import React from 'react';
import '../styles/Header.css';

const Header = ({ title, lead }) =>
  <div className="header">
    <h1 className="header__title">
      {title}
    </h1>
    <h3 className="header__lead" dangerouslySetInnerHTML={{ __html: lead }} />
  </div>;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js